import React from 'react'
import { Stack } from '@mui/material'

import { AutoReportDialog } from '@/components'
import { useRequestB2CReport } from '@/services'
import { B2CReportDialog } from '@/pages/b2c/components/b2c-report-dialog/b2c-report-dialog.tsx'
import { B2CPersonalSettings } from '@/pages/b2c/components/b2c-personal-settings.tsx'

import { NewB2CTransferDialog } from './new-b2c-transfer-dialog'
import { B2CToggleButtons } from './b2c-toggle-buttons.tsx'
import { NewB2CRegistryDialog } from './new-b2c-registry-dialog'
import { B2CDateRange, B2CFormReport } from './b2c-report-dialog'
import { useMobileSelect } from '@/hooks'

export const B2CActionButtons = (): React.ReactElement => {
  const { isMobile } = useMobileSelect()

  return (
    <Stack
      justifyContent="space-between"
      direction={isMobile ? { px1240: 'row', md: 'column' } : { px1640: 'row', md: 'column' }}
      gap={2}
    >
      <Stack justifyContent="flex-start" direction="row" gap={2}>
        <B2CToggleButtons />
      </Stack>
      <Stack
        justifyContent={isMobile ? { px1240: 'flex-end', md: 'flex-start' } : { px1640: 'flex-end', md: 'flex-start' }}
        direction={isMobile ? { px975: 'row', md: 'column' } : { px1350: 'row', md: 'column' }}
        gap={2}
      >
        <Stack alignItems="flex-start" direction={{ px526: 'row', xs: 'column' }} gap={2}>
          <NewB2CTransferDialog />
          <NewB2CRegistryDialog />
        </Stack>
        <Stack alignItems="flex-start" direction={{ px526: 'row', xs: 'column' }} gap={2}>
          <AutoReportDialog kind="B2C_SBP" />
          <B2CReportDialog<B2CFormReport> renderComponent={B2CDateRange} mutation={useRequestB2CReport()} />
        </Stack>
        <Stack alignItems="flex-start" direction={{ px526: 'row', xs: 'column' }} gap={2}>
          <B2CPersonalSettings />
        </Stack>
      </Stack>
    </Stack>
  )
}
